import { motion } from "framer-motion";
import { Quote, Star } from "lucide-react";

const TESTIMONIALS = [
  {
    name: "TecnoMundo Mayorista",
    role: "Distribuidor mayorista",
    quote:
      "Nexora se ha convertido en nuestro socio clave; su capacidad de importación nos permite tener las últimas tendencias en smartphones antes que la competencia.",
    avatar:
      "https://images.unsplash.com/photo-1655249493799-9cee4fe983bb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHw0fHxidXNpbmVzcyUyMHByb2Zlc3Npb25hbCUyMHBvcnRyYWl0fGVufDB8fHx8MTc3NzY3MzA0OHww&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Ing. Luis Paredes",
    role: "Especialista en redes",
    quote:
      "Los equipos de fibra óptica y el cableado que nos suministraron son de primer nivel; su asesoría técnica durante la instalación fue impecable.",
    avatar:
      "https://images.unsplash.com/photo-1581065178047-8ee15951ede6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwzfHxidXNpbmVzcyUyMHByb2Zlc3Npb25hbCUyMHBvcnRyYWl0fGVufDB8fHx8MTc3NzY3MzA0OHww&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Corporativo San José",
    role: "Cliente corporativo",
    quote:
      "Equipamos toda nuestra oficina con Nexora; la combinación de buenos precios en cómputo y el servicio de mantenimiento postventa es inigualable.",
    avatar:
      "https://images.unsplash.com/photo-1629507208649-70919ca33793?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMHByb2Zlc3Npb25hbCUyMHBvcnRyYWl0fGVufDB8fHx8MTc3NzY3MzA0OHww&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Sofía Ramos",
    role: "Cliente final",
    quote:
      "Compré mi equipo de sonido y TV con ellos; en Nexora me dieron una garantía real y el proceso de instalación en mi casa fue sumamente profesional.",
    avatar:
      "https://images.unsplash.com/photo-1629507313712-f21468afdf2e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwyfHxidXNpbmVzcyUyMHByb2Zlc3Npb25hbCUyMHBvcnRyYWl0fGVufDB8fHx8MTc3NzY3MzA0OHww&ixlib=rb-4.1.0&q=85",
  },
];

export const Testimonios = () => {
  return (
    <section
      id="testimonios"
      data-testid="testimonios-section"
      className="relative py-20 md:py-28 bg-[#f4f5f7]"
    >
      <div className="absolute inset-0 tech-grid-bg opacity-70" />
      <div className="relative max-w-[1400px] mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 mb-12">
          <div className="lg:col-span-7">
            <div className="font-mono-tech text-[11px] tracking-[0.32em] uppercase text-[#843C0C] mb-4 flex items-center gap-2">
              <span className="h-px w-8 bg-[#843C0C]" />
              Confianza
            </div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#203864] tracking-tight leading-[1.05]">
              Testimonios.
            </h2>
          </div>
          <div className="lg:col-span-5 lg:pt-4">
            <p className="text-[#3B3838]/80 text-base md:text-lg leading-relaxed">
              Mayoristas, ingenieros, corporativos y consumidores finales: todos respaldan
              la operación Nexora.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-[#3B3838]/15">
          {TESTIMONIALS.map((t, i) => (
            <motion.article
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-30px" }}
              transition={{ duration: 0.5, delay: i * 0.07 }}
              className="bg-white p-7 md:p-9 relative border-t-2 border-[#843C0C]"
              data-testid={`testimonial-${i}`}
            >
              <Quote className="absolute top-6 right-6 text-[#203864]/10" size={56} />
              <div className="flex gap-1 mb-5">
                {[...Array(5)].map((_, j) => (
                  <Star key={j} size={14} className="fill-[#843C0C] text-[#843C0C]" />
                ))}
              </div>
              <p className="text-[#3B3838] text-base md:text-lg leading-relaxed mb-7">
                "{t.quote}"
              </p>
              <div className="flex items-center gap-4 pt-5 border-t border-[#3B3838]/15">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="h-12 w-12 object-cover grayscale"
                />
                <div>
                  <div className="font-semibold text-[#203864] tracking-tight">
                    {t.name}
                  </div>
                  <div className="font-mono-tech text-[10px] tracking-[0.24em] uppercase text-[#843C0C]">
                    {t.role}
                  </div>
                </div>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};
